/*
 * @Author: Gaho
 * @Date: 2024-12-02 14:42:41
 * @LastEditors: Merlin
 * @LastEditTime: 2025-05-20 17:02:54
 * @Description: 
 */
// plugins/sentry.client.ts
import { defineNuxtPlugin } from '#app';
import * as Sentry from '@sentry/vue';

export default defineNuxtPlugin((nuxtApp) => {
    try{
        const isDev = import.meta.dev || import.meta.env.DEV_MODE;
        if (!isDev){
            console.log('Sentry starting');
            Sentry.init({
                app: nuxtApp.vueApp,
                // dsn: 'https://8c6fcb535d6540fd01c284497ce3a952@o4508396896518144.ingest.us.sentry.io/4508396898680832',
                dsn: "https://9342afc63464717e8ca1681278ec42c5@o4508408582701056.ingest.us.sentry.io/4508408701255680",
                integrations: [
                    Sentry.replayIntegration()
                ],
                // ↓ 采样率，设置为 1.0 表示采样所有请求，AI 回复表示 sentry.client.ts 内部对此值的设定优先级更高 
                // ↓ 设小值可减少 429 报错：详情 https://github.com/getsentry/sentry-javascript/issues/3066 
                tracesSampleRate: 0.75, // 采样率
                // Session Replay
                replaysSessionSampleRate: 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
                replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
                environment: process.env.NODE_ENV
            });
        }
    }catch(error){
        console.log('sentry error', error);
    }
});
